import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dadbefc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-round-summary" }
const _hoisted_2 = { style: {"margin-bottom":"375px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "k-round-title__preheader" }, " Tap to Continue ", -1))
const _hoisted_4 = { class: "k-round-title__header" }
const _hoisted_5 = {
  key: 0,
  class: "k-round-score mt1"
}
const _hoisted_6 = {
  key: 0,
  style: {"letter-spacing":"initial","font-weight":"200"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1))
const _hoisted_9 = { class: "k-round-score__multipliers" }
const _hoisted_10 = {
  key: 0,
  class: "bi bi-plus-circle"
}
const _hoisted_11 = {
  key: 1,
  class: "bi bi-arrow-down"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

import { Ref, onMounted, reactive, ref } from 'vue';
import { useMotion, useMotions } from '@vueuse/motion'
import { useModule } from 'src/modules/modules';
import ContrastText from './contrast-text.vue';
import GameContentArea from './game-content-area.vue';
import { hapticsImpactLight } from 'src/util/device-util';
import PointerFx from 'src/components/pointer-fx.vue';
import { getContrastColor } from 'util/color-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'round',
  emits: ['next'],
  setup(__props, { emit }) {

const { game, audio } = useModule();



let motionDurations = 400;
let counterDurations = 500;
const score = reactive({
    counter: 0,
    final: game.matchState.postRound.score,
    multipliers: game.matchState.postRound.multipliers,
    duration: game.matchState.postRound.multipliers.length * counterDurations
})

// let refs : { [key:string]: Ref<HTMLElement | undefined> } = {};
// score.multipliers.forEach((m, i) => {
//     refs[`multiplier${i}`] = ref<HTMLElement>();
// })

let counterEl = ref<HTMLElement>();
let multiplierRefs = ref<HTMLElement[]>();
onMounted(() => {
    let counterRect = counterEl.value?.getBoundingClientRect();
    if (!counterRect) return;

    let durationStep = counterDurations * 2;
    multiplierRefs.value?.forEach((el, i) => {
        let elRect = el.getBoundingClientRect();
        if (!elRect) return;
        
        el.style.transformOrigin = 'center left';


        //durationStep = 5000;
        //let distance = 1
        const { apply } = useMotion(el, {
            initial: {
                //scale: .75,
                opacity: 0,
                y: 150// + (i * 30),
            },
            enter: {
                opacity: 1,
                //scale: 1.25,
                y: (counterRect!.top - elRect.top) + 50,
                transition: {
                    type: 'keyframes',
                    ease: 'easeOut',
                    delay: ((durationStep / 2)) * i,
                    //duration: ((durationStep / 4) * 3),// * (i + 1),  //5000 * (i + 1), //durationStep,// - 100,
                    duration: ((durationStep / 2)),
                    //ease: 'linear',
                    //ease: 'linear',
                    onComplete: () => {
                        apply('leave');
                    }
                }
            },
            leave: {
                //scale: .75,
                opacity: 0,
                y: (counterRect!.top - elRect.top),
                transition: {
                    type: 'keyframes',
                    //duration: 500,
                    duration: ((durationStep / 2)),
                    ease: 'easeOut'
                }
            }
        })
    })

    //Phaser tween to increment score counter to final value
    let counter = { count: score.counter };
    game.gameScene?.add.tween({
        targets: counter,
        count: score.final,
        duration: score.duration,
        //ease: Phaser.Math.Easing.Cubic.Out,
        ease: Phaser.Math.Easing.Linear,
        onUpdate: (tween) => {
            score.counter = Math.floor(tween.getValue());
        }
    })

})


const titleEl = ref<HTMLElement>()
const titleMotion = useMotion(titleEl, {
    initial: {
        opacity: 0,
        y: 300
    },
    enter: {
        opacity: 1,
        y: 0,
        transition: {
            duration: motionDurations,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: 300,
        transition: {
            duration: motionDurations,
            ease: 'easeIn'
        },
    }
})

const scoreEl = ref<HTMLElement>()
const scoreMotion = useMotion(scoreEl, {
    initial: {
        opacity: 0,
        y: 300
    },
    enter: {
        opacity: 1,
        y: 0,
        delay: 100,
        transition: {
            duration: motionDurations,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: 300,
        transition: {
            duration: motionDurations,
            ease: 'easeIn'
        },
    }
})

const skipMessageEl = ref<HTMLElement>()
const skipMessageMotion = useMotion(skipMessageEl, {
    initial: {
        opacity: 0,
        y: 0
    },
    enter: {
        opacity: 1,
        transition: {
            duration: 2500,
            ease: 'easeOut'
        }
    },
    leave: {
        opacity: 0,
        y: -100,
        transition: {
            duration: motionDurations,
            ease: 'easeIn'
        },
    }
})

const ready = ref(false);
const transitioning = ref(false);
const handleClick = async () => {
    if (!transitioning.value && ready.value){
        transitioning.value = true;
        hapticsImpactLight();
        audio.play('FX_tap');
        await Promise.all([
            titleMotion.apply('leave'),
            scoreMotion.apply('leave'),
            skipMessageMotion.apply('leave')
        ])
        emit('next');
    }
}

onMounted(() => {
    setTimeout(() => {
        ready.value = true
    }, 500)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    onClick: handleClick,
    "hide-tray": true,
    "no-pointer-fx": ""
  }, {
    content: _withCtx(() => [
      _createVNode(PointerFx, {
        "color-start": _unref(getContrastColor)(_unref(game).currentBgColor),
        "color-end": _unref(getContrastColor)(_unref(game).currentBgColor)
      }, null, 8, ["color-start", "color-end"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "titleEl",
            ref: titleEl,
            class: "k-round-title"
          }, [
            _createVNode(ContrastText, {
              color: _unref(game).currentBgColor
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, " STAGE " + _toDisplayString(_unref(game).matchState.round), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ], 512),
          _createElementVNode("div", {
            ref_key: "scoreEl",
            ref: scoreEl
          }, [
            (_unref(game).matchState.round !== 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(ContrastText, {
                    color: _unref(game).currentBgColor
                  }, {
                    default: _withCtx(() => [
                      (_unref(game).matchState.postRound.score === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No Points Awarded "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", {
                              ref_key: "counterEl",
                              ref: counterEl,
                              class: "k-round-score__counter mb2"
                            }, [
                              _hoisted_8,
                              _createTextVNode(" " + _toDisplayString(score.counter) + " Points ", 1)
                            ], 512),
                            _createElementVNode("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(score.multipliers, (m, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  ref_for: true,
                                  ref_key: "multiplierRefs",
                                  ref: multiplierRefs,
                                  class: "k-round-score__multiplier"
                                }, [
                                  (m.score > 0)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                                  _createTextVNode(" " + _toDisplayString(m.score) + " " + _toDisplayString(m.label) + " ", 1),
                                  (m.factor > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (x" + _toDisplayString(m.factor) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ], 512))
                              }), 256))
                            ])
                          ]))
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ]),
        _createElementVNode("div", {
          ref_key: "skipMessageEl",
          ref: skipMessageEl,
          class: "k-round-skip-message"
        }, [
          (_unref(game).matchState.skips < 5)
            ? (_openBlock(), _createBlock(ContrastText, {
                key: 0,
                color: _unref(game).currentBgColor
              }, {
                default: _withCtx(() => [
                  (_unref(game).matchState.skips !== 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "You have " + _toDisplayString(_unref(game).matchState.skips) + " skips remaining.", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "You have " + _toDisplayString(_unref(game).matchState.skips) + " skip remaining.", 1))
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ], 512)
      ])
    ]),
    _: 1
  }))
}
}

})